import React, { useEffect, useState } from 'react';
import { getCurrentReader } from '../../auth/getCurrentReader';
import config from '../../services/publishingGroupConfig.json';
import { readerPrice } from '../../utils/readerAppreciation';

const pending = new Map();
let pendingReader;
function currentReader() {
  if (!pendingReader) pendingReader = getCurrentReader().finally(() => { pendingReader = null; });
  return pendingReader;
}
function participation(host) {
  if (!pending.has(host)) {
    const request = fetch(`${config.apiBase}/reader-appreciation?host=${encodeURIComponent(host)}`)
      .then(r => { if (!r.ok) throw new Error('Program unavailable'); return r.json(); })
      .then(data => data.enabled === true);
    pending.set(host, request);
    request.finally(() => pending.delete(host)).catch(() => {});
  }
  return pending.get(host);
}
export function useReaderAppreciation(host = window.location.hostname, readerOverride) {
  const [state, setState] = useState({ member: false, participating: false });
  useEffect(() => {
    let active = true;
    const load = async () => {
      const [reader, enabled] = await Promise.all([Promise.resolve(readerOverride === undefined ? currentReader() : readerOverride).catch(() => null), participation(host).catch(() => false)]);
      if (active) setState({ member: !!reader?.readerSub, participating: enabled });
    };
    load();
    window.addEventListener('focus', load);
    return () => { active = false; window.removeEventListener('focus', load); };
  }, [host, readerOverride]);
  return state;
}
export function AppreciationPrice({ price, format, host, compact = false }) {
  const { member, participating } = useReaderAppreciation(host);
  const retail = readerPrice(price, format);
  const discounted = readerPrice(price, format, participating, member);
  if (retail === null) return <>—</>;
  if (discounted === retail) return <>{retail === 0 ? 'Free' : `$${retail.toFixed(2)}`}</>;
  return <><del className="mr-2 text-bookish-purple/60">${retail.toFixed(2)}</del><span className="appreciation-price">{!compact && <span className="appreciation-price-label">Circle Reader Price </span>}<span>${discounted.toFixed(2)}</span></span></>;
}
export function AppreciationInvitation({ savings }) {
  return <aside className="my-4 rounded-xl border border-bookish-purple/20 bg-bookish-cream/40 p-4 text-sm text-bookish-purple">
    {savings > 0 && <p className="font-semibold">You could save ${savings.toFixed(2)} on this cart as a Circle Reader.</p>}
    <p>Become a Bookish Circle Reader and get 10% off physical books and bookish merch, plus $1 off ebooks priced $3 or more, from authors participating in Reader Appreciation.</p>
    <a className="underline font-semibold" href="https://bookishcircle.com/signupreader">Become a Circle Reader</a>
  </aside>;
}
export function ProductAppreciationNote({ price, format, host }) {
  const { member, participating } = useReaderAppreciation(host);
  const retail = readerPrice(price, format);
  const circlePrice = readerPrice(price, format, participating, true);
  if (retail === null || circlePrice === null || circlePrice >= retail) return null;
  return <p className="mt-2 text-sm leading-relaxed text-bookish-purple/80">
    {member ? <>Your Reader Appreciation discount is included in the Circle Reader price.</> : <><a href="https://bookishcircle.com/signupreader" className="underline underline-offset-2">Become a Circle Reader</a> to receive the Reader Appreciation discount on this book. Your member price: ${circlePrice.toFixed(2)}.</>}
  </p>;
}
